import React, { useEffect, createElement } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Nav } from './components/Nav';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { CookieConsent, getStoredConsent } from './components/CookieConsent';
import { Home } from './pages/Home';
import { HowItWorks } from './pages/HowItWorks';
import { WhatItFixes } from './pages/WhatItFixes';
import { GettingStarted } from './pages/GettingStarted';
import { Why } from './pages/Why';
import { Contact } from './pages/Contact';
import { PricingPage } from './pages/PricingPage';
import { YelpAds } from './pages/YelpAds';
import { WebsitesPage } from './pages/WebsitesPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsOfServicePage } from './pages/TermsOfServicePage';
import { RobotsTxt } from './pages/RobotsTxt';
import { SitemapXml } from './pages/SitemapXml';
import { CaseStudiesPage } from './pages/CaseStudiesPage';
import { TfpLandscapingPage } from './pages/CaseStudies/TfpLandscapingPage';
import { FinishCoatPaintingPage } from './pages/CaseStudies/FinishCoatPaintingPage';
import { GmailSignatureGeneratorPage } from './pages/tools/GmailSignatureGeneratorPage';
import { BlogPage } from './pages/BlogPage';
import { HowToChooseMarketingAgency } from './pages/blog/HowToChooseMarketingAgency';
import { WhyResponseTimeMakesOrBreaksYourYelpAds } from './pages/blog/WhyResponseTimeMakesOrBreaksYourYelpAds';
import { FasterYelpRepliesMoreLandscapingEstimates } from './pages/blog/FasterYelpRepliesMoreLandscapingEstimates';
import { AiReceptionistVsHumanReceptionistCost } from './pages/blog/AiReceptionistVsHumanReceptionistCost';
import { MissedCallTextBack } from './pages/blog/MissedCallTextBack';
import { AnsweringServiceForContractors } from './pages/AnsweringServiceForContractors';
import { BestAnsweringServiceSmallBusiness } from './pages/BestAnsweringServiceSmallBusiness';
import { MissedCallTextBackPage } from './pages/MissedCallTextBackPage';
import { CrmForContractors } from './pages/CrmForContractors';
import { AnsweringServicePhoenix } from './pages/AnsweringServicePhoenix';
import { GbpSetupPage } from './pages/GbpSetupPage';
function SiteLayout() {
  return <div className="flex min-h-screen flex-col bg-[#0a0a0a] font-sans text-neutral-100" data-id="element-0" data-mp="d2bgrcen7ptk">
      <Nav data-id="element-1" data-mp="83i23gnmdsrt" />
      {/* 2026-09-08 (compliance, Kevin): this noscript block is the raw HTML
          every non-JS crawler reads, so it is the highest-risk copy on the
          site. It listed a service link labelled "Reputation Management -
          Automated Reviews, Trust Building". Yelp flagged Viridia for review
          solicitation; that entry is removed. The remaining links point at
          routes that still resolve. Do not add review copy here.
          2026-09-15 (three-services restructure): added Yelp Ads and
          Websites, the two new real routes, per that handoff's item 6.
          2026-09-17 (local search build): added the five money pages and
          the re-routed Google Business Profile setup page. */}
      <noscript data-id="element-2" data-mp="1d4zpoj3m2kmr">
        <div style={{
        padding: '2rem',
        maxWidth: '800px',
        margin: '0 auto'
      }} data-id="element-3" data-mp="1d5j9648wth2w">
          <h1 data-id="element-4" data-mp="ydqxc28bql5x">
            Viridia Analytics - The Viridia System, Yelp Ads, and Websites for
            Phoenix Home Service Businesses
          </h1>
          <p data-id="element-5" data-mp="1r5ahppgnq59i">
            We help local service businesses stop missing leads, respond
            instantly, and book more jobs. Real systems, real results from real
            Phoenix-area clients.
          </p>
          <h2 data-id="element-6" data-mp="1i319j68v2nza">Our Services</h2>
          <ul data-id="element-7" data-mp="1i5x72tgsran7">
            <li data-id="element-8" data-mp="1m4wag9mvqzcj">
              <a href="/how-it-works" data-id="element-9" data-mp="1m4eivqb5x9ay">
                The Viridia System - CRM, AI Receptionist, Automation, $897 a month
              </a>
            </li>
            <li data-id="element-10" data-mp="6qs55rohpg4n">
              <a href="/yelp-ads" data-id="element-11" data-mp="aq0umkchyrue">
                Yelp Ads Management - Run by a Former Yelp Rep
              </a>
            </li>
            <li data-id="element-12" data-mp="qy73v2csh393">
              <a href="/websites" data-id="element-13" data-mp="qyqavo0wi78c">Websites - Built and Hosted by Viridia</a>
            </li>
          </ul>
          <h2 data-id="element-14" data-mp="m4udonsgooe8">Answering Service and CRM</h2>
          <ul data-id="element-15" data-mp="h72po4uxtmfb">
            <li data-id="element-16" data-mp="h6kkuju7lzvs">
              <a href="/answering-service-for-contractors" data-id="element-17" data-mp="h8dpxup6cc1o">
                Answering Service for Contractors
              </a>
            </li>
            <li data-id="element-18" data-mp="c6eq2usn7x9h">
              <a href="/best-answering-service-for-small-business" data-id="element-19" data-mp="19vrjditnyph1">
                Best Answering Service for Small Business
              </a>
            </li>
            <li data-id="element-20" data-mp="14xpycscogg2x">
              <a href="/missed-call-text-back" data-id="element-21" data-mp="14v3tj0h68eoe">Missed Call Text Back</a>
            </li>
            <li data-id="element-22" data-mp="zzww2aehw67x">
              <a href="/crm-for-contractors" data-id="element-23" data-mp="vw8nboe4n4l3">CRM for Contractors</a>
            </li>
            <li data-id="element-24" data-mp="vyb9tyg2mfl2">
              <a href="/answering-service-phoenix" data-id="element-25" data-mp="3ko2t2sdw98wq">
                Answering Service in Phoenix
              </a>
            </li>
            <li data-id="element-26" data-mp="3gm7pfh8hqjfs">
              <a href="/google-business-profile-setup" data-id="element-27" data-mp="3globeblyof71">
                Google Business Profile Setup
              </a>
            </li>
          </ul>
          <h2 data-id="element-28" data-mp="2060cnyut57si">Contact Us</h2>
          <p data-id="element-29" data-mp="2058t5mehj0il">
            Phone: <a href="tel:6233000708" data-id="element-30" data-mp="206jttdcmvs5h">(623) 300-0708</a>
          </p>
          <p data-id="element-31" data-mp="254lfm61g25kn">
            Email:{' '}
            <a href="mailto:info@viridiaanalytics.com" data-id="element-32" data-mp="253jxjhm0gitf">
              info@viridiaanalytics.com
            </a>
          </p>
          <p data-id="element-33" data-mp="29xoachhyjl2f">Location: Phoenix, AZ 85050 - Serving the Phoenix Metro</p>
          <h2 data-id="element-34" data-mp="2eueqf4trignu">Quick Links</h2>
          <ul data-id="element-35" data-mp="2ex9agv8v5zgq">
            <li data-id="element-36" data-mp="2jtr9rflfd5lo">
              <a href="/why" data-id="element-37" data-mp="2jt816phnztkb">Why Viridia</a>
            </li>
            <li data-id="element-38" data-mp="2jvu9wsgakf44">
              <a href="/case-studies" data-id="element-39" data-mp="2nvunkavkgma4">Case Studies</a>
            </li>
            <li data-id="element-40" data-mp="2nti4tvhzi7w0">
              <a href="/pricing" data-id="element-41" data-mp="2supddwrybb3q">Pricing</a>
            </li>
            <li data-id="element-42" data-mp="2su5ykoxll2tx">
              <a href="/contact" data-id="element-43" data-mp="2sslbtlhiyo6m">Book a 15-min call</a>
            </li>
            <li data-id="element-44" data-mp="tivaaoens460">
              <a href="/privacy" data-id="element-45" data-mp="tjeiveif5g7d">Privacy Policy</a>
            </li>
            <li data-id="element-46" data-mp="yhprxn0w3moj">
              <a href="/terms" data-id="element-47" data-mp="yh6lp3klqmqc">Terms of Service</a>
            </li>
          </ul>
        </div>
      </noscript>
      <main role="main" className="flex-grow" data-id="element-48" data-mp="21ru67cxjqdfc">
        <Routes data-id="element-49" data-mp="1wt0sbjeckken">
          <Route path="/" element={<Home data-id="element-51" data-mp="1wu25puiu5izj" />} data-id="element-50" data-mp="1wtiyp8uq4f0a" />
          <Route path="/how-it-works" element={<HowItWorks data-id="element-53" data-mp="2ass3lcdhbmoy" />} data-id="element-52" data-mp="1wuu1b5cfngpt" />
          <Route path="/what-it-fixes" element={<WhatItFixes data-id="element-55" data-mp="2apw4vltt4tzg" />} data-id="element-54" data-mp="2at1sewmsfnt2" />
          <Route path="/getting-started" element={<GettingStarted data-id="element-57" data-mp="25rm8x909dpcs" />} data-id="element-56" data-mp="25snu46azns88" />
          <Route path="/why" element={<Why data-id="element-59" data-mp="2kpwol8vl9c46" />} data-id="element-58" data-mp="25viexyxwzf26" />
          <Route path="/pricing" element={<PricingPage data-id="element-61" data-mp="2kolkf7y8e2cj" />} data-id="element-60" data-mp="2kpen9xu2k7pe" />
          <Route path="/yelp-ads" element={<YelpAds data-id="element-63" data-mp="2fqae3775a9z2" />} data-id="element-62" data-mp="2frd6jjk48kh3" />
          <Route path="/websites" element={<WebsitesPage data-id="element-65" data-mp="2tiqkmhz98q4q" />} data-id="element-64" data-mp="2fqttag5euk9e" />
          <Route path="/contact" element={<Contact data-id="element-67" data-mp="2ti8hd1e6dbnb" />} data-id="element-66" data-mp="2tizzb9eunav4" />
          {/* 2026-09-17 (local search build, Kevin's "Go"): the five money
              pages from the 2026-08-13 keyword realignment, plus the Google
              Business Profile setup page routed again instead of redirecting. */}
          <Route path="/answering-service-for-contractors" element={<AnsweringServiceForContractors data-id="element-69" data-mp="3i3mu2ipdol3m" />} data-id="element-68" data-mp="2yicvwlvivwaw" />
          <Route path="/best-answering-service-for-small-business" element={<BestAnsweringServiceSmallBusiness data-id="element-71" data-mp="3n1eqnq0ywve5" />} data-id="element-70" data-mp="3i463fb0yq161" />
          <Route path="/missed-call-text-back" element={<MissedCallTextBackPage data-id="element-73" data-mp="384xc6pxhf0nd" />} data-id="element-72" data-mp="385p6lxfcesc2" />
          <Route path="/crm-for-contractors" element={<CrmForContractors data-id="element-75" data-mp="3d38n73zijh76" />} data-id="element-74" data-mp="3d4jpt0h82iwp" />
          <Route path="/answering-service-phoenix" element={<AnsweringServicePhoenix data-id="element-77" data-mp="2zcvdaw329sf7" />} data-id="element-76" data-mp="3d6mpydc39sf5" />
          <Route path="/google-business-profile-setup" element={<GbpSetupPage data-id="element-79" data-mp="3443onxnybnv0" />} data-id="element-78" data-mp="2zbu0on6ecxvd" />
          <Route path="/services" element={<Navigate to="/how-it-works" replace data-id="element-81" data-mp="345ompx9h5oxm" />} data-id="element-80" data-mp="345et7zp80zn6" />
          <Route path="/ai-lead-conversion" element={<Navigate to="/how-it-works" replace data-id="element-83" data-mp="2pd4isuei3df4" />} data-id="element-82" data-mp="2pga9uf6owpdh" />
          <Route path="/automations" element={<Navigate to="/how-it-works" replace data-id="element-85" data-mp="2ubxzevp33kji" />} data-id="element-84" data-mp="2uf3nq8pw2ie6" />
          <Route path="/custom-automations" element={<Navigate to="/how-it-works" replace data-id="element-87" data-mp="2ggdrswet2ore" />} data-id="element-86" data-mp="2ge10hsn5r21o" />
          <Route path="/crm-business-tools" element={<Navigate to="/crm-for-contractors" replace data-id="element-89" data-mp="2kf2zq9h2re3n" />} data-id="element-88" data-mp="2kg4f2q54imr6" />
          <Route path="/reputation-management" element={<Navigate to="/how-it-works" replace data-id="element-91" data-mp="30tautrq3xa0x" />} data-id="element-90" data-mp="30vn8hsou0y86" />
          {/* 2026-09-15 (three-services restructure, item 6): /ad-campaigns
              now points at the new Yelp Ads Management page instead of the
              generic How It Works page -- the redirect target changed, the
              route itself did not. */}
          <Route path="/ad-campaigns" element={<Navigate to="/yelp-ads" replace data-id="element-93" data-mp="2hxkra02j05kx" />} data-id="element-92" data-mp="2hwj4wzg27wnw" />
          {/* 2026-09-15 (three-services restructure, item 6): /web-design-seo
              now points at the new dedicated Websites page instead of the
              combined Pricing page. */}
          <Route path="/web-design-seo" element={<Navigate to="/websites" replace data-id="element-95" data-mp="23851amatk46a" />} data-id="element-94" data-mp="284lo9d6a8chs" />
          <Route path="/about" element={<Navigate to="/why" replace data-id="element-97" data-mp="1y8io2cuzqnxh" />} data-id="element-96" data-mp="239g4ol0cr9wv" />
          <Route path="/case-studies" element={<CaseStudiesPage data-id="element-99" data-mp="1yad17500tbr0" />} data-id="element-98" data-mp="1y78qdos1vhrd" />
          <Route path="/case-studies/tfp-landscaping" element={<TfpLandscapingPage data-id="element-101" data-mp="1u7qefii7ih0o" />} data-id="element-100" data-mp="1u6f2uwiis4z0" />
          <Route path="/case-studies/finish-coat-painting" element={<FinishCoatPaintingPage data-id="element-103" data-mp="9r8skelfpyub" />} data-id="element-102" data-mp="9p65o3fkwltt" />
          <Route path="/blog" element={<BlogPage data-id="element-105" data-mp="doohm9pf9mki" />} data-id="element-104" data-mp="dpgdzmqufobu" />
          <Route path="/blog/how-to-choose-marketing-agency" element={<HowToChooseMarketingAgency data-id="element-107" data-mp="inhsdudbqzgz" />} data-id="element-106" data-mp="ipku3bnuah1j" />
          <Route path="/blog/why-response-time-makes-or-breaks-your-yelp-ads" element={<WhyResponseTimeMakesOrBreaksYourYelpAds data-id="element-109" data-mp="3m7chsduy0etx" />} data-id="element-108" data-mp="nnmbzt9j4abf" />
          <Route path="/blog/faster-yelp-replies-more-landscaping-estimates" element={<FasterYelpRepliesMoreLandscapingEstimates data-id="element-111" data-mp="3w4qwo917wvk4" />} data-id="element-110" data-mp="3r54k81t7rjcd" />
          <Route path="/blog/ai-receptionist-vs-human-receptionist-cost" element={<AiReceptionistVsHumanReceptionistCost data-id="element-113" data-mp="4r4dmt06dc67" />} data-id="element-112" data-mp="3w2e5r6dhfaux" />
          <Route path="/blog/missed-call-text-back-phoenix-home-services" element={<MissedCallTextBack data-id="element-115" data-mp="38dux2pqisw2b" />} data-id="element-114" data-mp="33es443ntegap" />
          <Route path="/f/why-response-time-makes-or-breaks-your-yelp-ads" element={<Navigate to="/blog/why-response-time-makes-or-breaks-your-yelp-ads" replace data-id="element-117" data-mp="2k682lm9zel5r" />} data-id="element-116" data-mp="38ctk2fpy1zhy" />
          <Route path="/f/faster-yelp-replies-more-landscaping-estimates" element={<Navigate to="/blog/faster-yelp-replies-more-landscaping-estimates" replace data-id="element-119" data-mp="2u3mhvik653wh" />} data-id="element-118" data-mp="2p5ugzz1jq7g5" />
          <Route path="/tools/gmail-signature-generator" element={<GmailSignatureGeneratorPage data-id="element-121" data-mp="26f39l314cr4e" />} data-id="element-120" data-mp="21exh5kn0z0l9" />
          <Route path="/privacy" element={<PrivacyPolicyPage data-id="element-123" data-mp="2b5joysoi2mte" />} data-id="element-122" data-mp="26diencaw7660" />
          <Route path="/terms" element={<TermsOfServicePage data-id="element-125" data-mp="2b6urkp67loix" />} data-id="element-124" data-mp="2b6lbpuevoxqy" />
        </Routes>
      </main>
      <Footer data-id="element-126" data-mp="1dqxogf65l041" />
      <CookieConsent data-id="element-127" data-mp="1dpct4nc0ld54" />
    </div>;
}
export function App() {
  useEffect(() => {
    // Cookie-consent gate (added 2026-08-04): a declined choice stored from
    // a previous visit skips these scripts entirely. An accepted or
    // not-yet-decided visitor still gets them by default -- CookieConsent's
    // banner still shows either way so the choice is disclosed, matching
    // the site's own Privacy Policy (which already names Meta/Google as
    // third parties). A decision made THIS session can't un-fire a pixel
    // that already loaded before the banner was clicked, but it's honored
    // on every subsequent page load for as long as it's stored.
    if (getStoredConsent() === 'declined') {
      return;
    }
    // Google Analytics (gtag.js)
    const GA_MEASUREMENT_ID = 'G-C4JZKB2BFQ';
    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(gtagScript);
    const gtagInit = document.createElement('script');
    gtagInit.text = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${GA_MEASUREMENT_ID}');
    `;
    document.head.appendChild(gtagInit);
    // Meta Pixel
    const fbScript = document.createElement('script');
    fbScript.text = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '970566142171718');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(fbScript);
    const fbNoscript = document.createElement('noscript');
    const fbImg = document.createElement('img');
    fbImg.height = 1;
    fbImg.width = 1;
    fbImg.style.display = 'none';
    fbImg.src = 'https://www.facebook.com/tr?id=970566142171718&ev=PageView&noscript=1';
    fbNoscript.appendChild(fbImg);
    document.body.appendChild(fbNoscript);
    // GHL Chat Widget
    const chatDiv = document.createElement('div');
    chatDiv.setAttribute('data-chat-widget', '');
    chatDiv.setAttribute('data-widget-id', '69ced0ba10e73a6e4e745753');
    chatDiv.setAttribute('data-location-id', 'JLycxFbUVQFY3z4zPpCS');
    document.body.appendChild(chatDiv);
    const script = document.createElement('script');
    script.src = 'https://widgets.leadconnectorhq.com/loader.js';
    script.setAttribute('data-resources-url', 'https://widgets.leadconnectorhq.com/chat-widget/loader.js');
    script.setAttribute('data-widget-id', '69ced0ba10e73a6e4e745753');
    document.body.appendChild(script);
    return () => {
      if (gtagScript.parentNode) gtagScript.parentNode.removeChild(gtagScript);
      if (gtagInit.parentNode) gtagInit.parentNode.removeChild(gtagInit);
      if (fbScript.parentNode) fbScript.parentNode.removeChild(fbScript);
      if (fbNoscript.parentNode) fbNoscript.parentNode.removeChild(fbNoscript);
      if (chatDiv.parentNode) chatDiv.parentNode.removeChild(chatDiv);
      if (script.parentNode) script.parentNode.removeChild(script);
    };
  }, []);
  return <BrowserRouter data-id="element-128" data-mp="vml0y1qplr0q">
      <ScrollToTop data-id="element-129" data-mp="vn48coiqgx0i" />
      <Routes data-id="element-130" data-mp="vnns8ary1vh6">
        <Route path="/robots.txt" element={<RobotsTxt data-id="element-132" data-mp="10lp86mu2peof" />} data-id="element-131" data-mp="vo5txmxdl1wh" />
        <Route path="/sitemap.xml" element={<SitemapXml data-id="element-134" data-mp="10l60s021u8on" />} data-id="element-133" data-mp="10m7e6b6jf79j" />
        <Route path="/*" element={<SiteLayout data-id="element-136" data-mp="15kinmksx7fr8" />} data-id="element-135" data-mp="10juxs2gfh4yl" />
      </Routes>
    </BrowserRouter>;
}